import TableWithTitle from "@/components/TableWithTitle.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import { getDescriptionBasedOnKpiKey, getColorsBasedOnRange, getColorForDecile } from "@/utils/transformers";
import { capitalizeWords } from "@/utils";
import { SELECTOR, PERIOD_FIELD, DSP_CONSIDERATION_SIGNALS_FIELD, DSP_DPVR_VS_TARGET_FIELD, DSP_CPA_CONSIDERATION_FIELD, DSP_SPEND_FIELD, DSP_DPV_FIELD, DSP_ATC_FIELD, DSP_BRAND_SEARCHES_FIELD, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, DSP_DELIVERY_RATE_FIELD, DSP_PERCENT_NTB_CUST_FIELD, DSP_PERCENT_DPV_CLICK_FIELD } from "@/utils/table_fields";
import AppIcon from "@/components/AppIcon.vue";
import { mapState } from "vuex";
import { HugValue, DateValue, CurrencyValue, NumberValue, PercentageValue, BoxedValue, BarWithValue, OverlapBarValue } from "@/components/tableElements";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import { DEFAULT_DATE_FORMATS, PERIOD_COLUMN_TITLES, ECPM_DECILE_COLORS, DSP_DELIVERY_RATE_BG_COLORS, DSP_DELIVERY_RATE_COLORS, DSP_NTB_CUSTOMERS_RATE_COLORS, DSP_NTB_CUSTOMERS_RATE_BG_COLORS } from "@/utils/constants";
import FlexRow from "@/components/FlexRow.vue";
import moment from "moment";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import WrapTableWithShowMore from "@/components/WrapTableWithShowMore.vue";
import TextValue from "@/components/tableElements/TextValue.vue";
export default {
  name: "ConsiderationPeriodTable",
  components: {
    HugValue,
    DateValue,
    CurrencyValue,
    NumberValue,
    PercentageValue,
    SlotWithEvolutionValue,
    EvolutionValue,
    WrapTableWithShowMore,
    TextValue,
    WrapWithPopover,
    TableWithTitle,
    FlexRow,
    AppIcon,
    BoxedValue,
    BarWithValue,
    OverlapBarValue
  },
  mixins: [LiteTableMixin],
  props: {
    loading: {
      typ: Boolean,
      required: true
    }
  },
  emits: ["setDateRange", "refresh"],
  data() {
    return {
      PERIOD_COLUMN_TITLES,
      ECPM_DECILE_COLORS,
      DSP_DELIVERY_RATE_BG_COLORS,
      DSP_DELIVERY_RATE_COLORS,
      DSP_NTB_CUSTOMERS_RATE_COLORS,
      DSP_NTB_CUSTOMERS_RATE_BG_COLORS,
      fields: [SELECTOR, PERIOD_FIELD, DSP_CONSIDERATION_SIGNALS_FIELD, DSP_DPVR_VS_TARGET_FIELD, DSP_CPA_CONSIDERATION_FIELD, DSP_SPEND_FIELD, DSP_DPV_FIELD, DSP_ATC_FIELD, {
        ...DSP_BRAND_SEARCHES_FIELD,
        class: ["right-embrace", "left-embrace", "brand_interest"]
      }, DSP_ECPM_FIELD, DSP_IMPRESSIONS_FIELD, DSP_VTR_FIELD, DSP_DELIVERY_RATE_FIELD, DSP_PERCENT_NTB_CUST_FIELD, DSP_PERCENT_DPV_CLICK_FIELD],
      evolCategory: {
        prev_period: "_vs_previous_period",
        same_period_ly: "_vs_last_year"
      }
    };
  },
  computed: {
    ...mapState({
      periodTable: state => state.dsp_report.periodTable,
      tab: state => state.dsp_report.currentTabValue,
      period: state => state.dsp_report.period,
      currentPeriod: state => state.dsp_report.currentPeriod,
      periodCategory: state => state.dsp_report.periodCategory
    }),
    items() {
      return this.periodTable[this.tab].items;
    },
    maxCharCount() {
      return this.periodTable[this.tab].maxCharCount;
    },
    minMax() {
      return this.periodTable[this.tab].minMax;
    },
    getDateValueFormat() {
      // Convert the current period to UPPER CASE
      const period = this.period.toUpperCase();
      return DEFAULT_DATE_FORMATS[period];
    },
    getPeriodColumnTitle() {
      return PERIOD_COLUMN_TITLES[this.period];
    },
    period_pager: {
      get() {
        return this.periodTable.period_page;
      },
      set(_) {
        this.$store.dispatch("dspIncrementPeriodPage");
        this.$emit("refresh");
      }
    }
  },
  methods: {
    getDescriptionBasedOnKpiKey,
    getColorsBasedOnRange,
    capitalizeWords,
    getColorForDecile,
    handleDateClick(period) {
      period = moment(period);
      this.$emit("setDateRange", period);
    },
    handleDateReset() {
      this.$emit("setDateRange", null);
    },
    handleRowClick(item) {
      this.handleRowClicked(item, this.handleDateReset, this.handleDateClick, "period_agg");
    }
  }
};